import Request from '@/utils/request'

export type TResponseData<T> = {
    code: 0 | number // 0 => ok
    msg: string
    data: T
}
export const getTaskList = (data:any) => {
    return Request.axiosInstance({url: '/H5SignApi/getTaskList',method: 'post', data})
}
// 签约授权书
export const h5SignFile = (data:any) => {
    return Request.axiosInstance({url: '/H5SignApi/getPowerOfAttorneySignUrl',method: 'post', data})
}
// 签约C端协议
export const h5SignContract = (data:any) => {
    return Request.axiosInstance({url: '/H5SignApi/signCEndAgreement',method: 'post', data})
}
export const cardVerify = (data:any) => {
    return Request.axiosInstance({url: '/H5SignApi/idCardOCR',method: 'post', data})
}
export const getPageData = (data:any) => {
    return Request.axiosInstance({url: '/H5SignApi/getOemConfig',method: 'post', data})
}

export const getHetong = (data:any) => {
    return Request.axiosInstance({url: '/H5sign/get_hetong_new',method: 'post', data})
}

